import React, { Component } from 'react';
import { authInstance } from './AuthService';
import './Main.css';

const isValidEmail = (email) => {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const isEmailValid = re.test(email);
    return isEmailValid;
}

//initialize form variables and set length to zero - tmp
const validate = function(fullName='', email='', clientName='', buildingName='', message='') {
    // true means invalid, so our conditions got reversed - tmp
    return {
        fullName: fullName.length == 0,
        email: !isValidEmail(email),
        clientName: clientName ? clientName.length === 0: false,
        buildingName: buildingName ? buildingName.length === 0: false,
        message: message.length === 0
    };
}

class Contactus extends Component {
    constructor(props) {
        super(props);
        this.Auth = authInstance;

        const userProfile = this.Auth ? this.Auth.getProfile() : undefined;
        const userName = userProfile.sub;
        // let userFullName = '' // set full name from profile after API work is completed
        // if (userName === 'hwilliams') userFullName = 'Hobby Williams'
        // else if (userName === 'ggraff') userFullName = 'ggr aff'
        // else if (userName === 'bbb') userFullName = 'BBB'
        // else userFullName = 'No Name' //fallback

        this.state = {
            fullName: '',
            email: '',
            clientName: props.clientName || '',
            buildingName: props.buildingName || '',
            message: props.noSegmentsFound ? 'No Segments Found': '',
            
            //tmp
            touched: {
                fullName: false,
                email: false,
                clientName: false,
                buildingName: false,
                message: false,
            },
        };

        this.change = this.change.bind(this)
    }

    componentWillReceiveProps(props) {
        this.setState({
          clientName: props.clientName,
          buildingName: props.buildingName,
          message: props.noSegmentsFound ? 'No Segment Found': ''
        })
      }

    //allow form elements to be modified
    change = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    //tmp 
    handleBlur = (field) => (e) => {
        this.setState({
        touched: { ...this.state.touched, [field]: true },
        });
    }
    //tmp
    handleSubmit = (e) => {
        if (!this.canBeSubmitted()) {
          e.preventDefault();
          return;
        }
        const { fullName, email, clientName, buildingName, message } = this.state;
        alert(`Confirm the following fullName: ${fullName} email: ${email} clientName: ${clientName} buildingName ${buildingName} $message ${message}`);
      }

      //tmp
      canBeSubmitted() {
        const errors = validate(this.state.fullName, this.state.email, this.state.clientName, this.state.buildingName, this.state.message);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return !isDisabled;
      }
    
    render() {
        //tmp
        const errors = validate(this.state.fullName, this.state.email, this.state.clientName, this.state.buildingName, this.state.message);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //tmp
        const shouldMarkError = (field) => {
            const hasError = errors[field];
            const shouldShow = this.state.touched[field];
            
            return hasError ? shouldShow : false;
        };

        const { clientName = '', buildingName = '' } = this.state;
        const { noSegmentsFound } = this.props;
        
        return (
            <div className="help-container">
            <p>Please contact <a className="contact_lnk" href="mailto:support@cenergistic.com">support@cenergistic.com</a> for assistance.</p>
                {/* <form action="/send-email" method="post" onSubmit={this.handleSubmit}>
                    <label htmlFor="fullName">Full Name:</label>
                    <input
                        placeholder="Full Name"
                        name="fullName"
                        type="text"
                        value={this.state.fullName}
                        onChange={e => this.change(e)}
                        className="form-control"
                        onBlur={this.handleBlur('fullName')}
                    /> <br />
                    <label htmlFor="email">Email Address:</label>
                    <input
                        placeholder="Email"
                        name="email"
                        type="email"
                        value={this.state.email}
                        onChange={e => this.change(e)}
                        className="form-control"
                        onBlur={this.handleBlur('email')}
                    /> <br />
                    <label htmlFor="clientName">Client Name:</label>
                    <input
                        placeholder="Client Name"
                        name="clientName"
                        type="text"
                        value={clientName}
                        onChange={e => this.change(e)}
                        className="form-control"
                        onBlur={this.handleBlur('clientName')}
                    /> <br />
                    <label htmlFor="buildingName">Building Name:</label>
                    <input
                        placeholder="Building Name"
                        name="buildingName"
                        type="text"
                        value={buildingName}
                        onChange={e => this.change(e)}
                        className="form-control"
                        onBlur={this.handleBlur('buildingName')}
                    /> <br />
                    <textarea rows="4" cols="70"
                        placeholder="Message"
                        name="message"
                        type="textarea"
                        value={this.state.message}
                        onChange={e => this.change(e)}
                        className="form-control"
                        onBlur={this.handleBlur('message')}
                    >

                    </textarea> <br /><br />

                    <button disabled={isDisabled} className="btn btn-success" type="button">Submit</button>
                </form> */}
            </div>
        );
    }

}
export default Contactus


// WEBPACK FOOTER //
// ./src/components/Contactus.js